<kzn-dialog title="" [actionLabel]="t('ersdContinue')" [secondaryActionLabel]="t('decline')" [isActionDisabled]="!ersdAcceptance.value"
    [isCancelDisabled]="ersdAcceptance.value" (actionFired)="onAction()" (secondaryActionFired)="openDeclineDialog()">
    <div class="content__ersd-acceptance">
        <div class="ersd-lang-row">
            <img src="assets/language.png" alt="Language" class="ersd-lang-icon" />
            <select class="ersd-lang-select" [(ngModel)]="currentLanguage" (ngModelChange)="onLanguageSelect($event)" aria-label="Select language">
                @for (opt of languageOptions; track opt.value) {
                    <option [value]="opt.value">{{ opt.label }}</option>
                }
            </select>
        </div>
        <div class="message__ersd-acceptance il-margin">
            <span class="text-bold__ersd-acceptance">{{ tParams('ersdMessageFrom', { requesterName: data.requesterName, customerName: data.customerName }) }}</span>
            <span style="line-height: normal;">{{ data.requesterMessage }}</span>
        </div>
        <div>
            <mat-accordion>
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>{{ t('ersdDisclosureTitle') }}</mat-panel-title>
                    </mat-expansion-panel-header>
                    <div [innerHTML]="safeEulaMessage"></div>
                </mat-expansion-panel>
            </mat-accordion>
            <mat-checkbox [formControl]="ersdAcceptance" color="primary" class="checkbox__ersd-acceptance">
                <span [innerHTML]="ersdAgreeCheckboxHtml"></span>
            </mat-checkbox>
        </div>
    </div>
</kzn-dialog>